export const NEXTHINK_TASK_STATUS_LABELS: Record<
  string,
  { progress: string; success: string; failure: string }
> = {
  '#disk_cleanup_deep': {
    progress: 'chatBot.nexthinkIntegration.diskClean.progressMsg',
    success: 'chatBot.nexthinkIntegration.diskClean.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.diskClean.failureMsg',
  },
  '#disk_cleanup_light': {
    progress: 'chatBot.nexthinkIntegration.diskClean.progressMsg',
    success: 'chatBot.nexthinkIntegration.diskClean.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.diskClean.failureMsg',
  },
  '#clear_chrome_cache': {
    progress: 'chatBot.nexthinkIntegration.chromeCache.progressMsg',
    success: 'chatBot.nexthinkIntegration.chromeCache.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.chromeCache.failureMsg',
  },
  '#clear_microsoft_edge_settings_gsd': {
    progress: 'chatBot.nexthinkIntegration.edgeCache.progressMsg',
    success: 'chatBot.nexthinkIntegration.edgeCache.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.edgeCache.failureMsg',
  },
  '#repair_empower_addin': {
    progress: 'chatBot.nexthinkIntegration.empowerApp.progressMsg',
    success: 'chatBot.nexthinkIntegration.empowerApp.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.empowerApp.failureMsg',
  },
  '#check_set_empower_plugin_status': {
    progress: 'chatBot.nexthinkIntegration.empowerPlugin.progressMsg',
    success: 'chatBot.nexthinkIntegration.empowerPlugin.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.empowerPlugin.failureMsg',
  },
  '#clear_microsoft_teams_work_or_school_cache_no_campaign': {
    progress: 'chatBot.nexthinkIntegration.teamsCache.progressMsg',
    success: 'chatBot.nexthinkIntegration.teamsCache.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.teamsCache.failureMsg',
  },
  '#repair_teams_application_with_live_notification': {
    progress: 'chatBot.nexthinkIntegration.teamsReinstall.progressMsg',
    success: 'chatBot.nexthinkIntegration.teamsReinstall.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.teamsReinstall.failureMsg',
  },
  repair_outlook_ost_problem_windows: {
    progress: 'chatBot.nexthinkIntegration.outlookOst.progressMsg',
    success: 'chatBot.nexthinkIntegration.outlookOst.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.outlookOst.failureMsg',
  },
  repair_office_365_windows: {
    progress: 'chatBot.nexthinkIntegration.repairOfficeApps.progressMsg',
    success: 'chatBot.nexthinkIntegration.repairOfficeApps.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.repairOfficeApps.failureMsg',
  },
  '#trigger_intune_sync': {
    progress: 'chatBot.nexthinkIntegration.intuneSync.progressMsg',
    success: 'chatBot.nexthinkIntegration.intuneSync.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.intuneSync.failureMsg',
  },
  '#repair_microsoft_teams_addin': {
    progress: 'chatBot.nexthinkIntegration.teamsAddin.progressMsg',
    success: 'chatBot.nexthinkIntegration.teamsAddin.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.teamsAddin.failureMsg',
  },
  invoke_windows_update_windows: {
    progress: 'chatBot.nexthinkIntegration.windowsUpdate.progressMsg',
    success: 'chatBot.nexthinkIntegration.windowsUpdate.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.windowsUpdate.failureMsg',
  },
  '#set_timezone_auto_update': {
    progress: 'chatBot.nexthinkIntegration.timezone.progressMsg',
    success: 'chatBot.nexthinkIntegration.timezone.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.timezone.failureMsg',
  },
  clear_outlook_autocomplete_cache_windows: {
    progress: 'chatBot.nexthinkIntegration.outlookAutoComplete.progressMsg',
    success: 'chatBot.nexthinkIntegration.outlookAutoComplete.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.outlookAutoComplete.failureMsg',
  },
  reset_zscaler_connection: {
    progress: 'chatBot.nexthinkIntegration.restartZscalar.progressMsg',
    success: 'chatBot.nexthinkIntegration.restartZscalar.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.restartZscalar.failureMsg',
  },
  repair_onedrive_windows: {
    progress: 'chatBot.nexthinkIntegration.onedrive.progressMsg',
    success: 'chatBot.nexthinkIntegration.onedrive.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.onedrive.failureMsg',
  },
  '#remove_microsoft_virtual_smart_cards': {
    progress: 'chatBot.nexthinkIntegration.smartcard.progressMsg',
    success: 'chatBot.nexthinkIntegration.smartcard.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.smartcard.failureMsg',
  },
  '#team_viewer_restart_service': {
    progress: 'chatBot.nexthinkIntegration.teamViewerReset.progressMsg',
    success: 'chatBot.nexthinkIntegration.teamViewerReset.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.teamViewerReset.failureMsg',
  },
  '#zoom_full_uninstallation': {
    progress: 'chatBot.nexthinkIntegration.zoomUninstall.progressMsg',
    success: 'chatBot.nexthinkIntegration.zoomUninstall.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.zoomUninstall.failureMsg',
  },
  '#cisco_webex_full_uninstallation': {
    progress: 'chatBot.nexthinkIntegration.webexUninstall.progressMsg',
    success: 'chatBot.nexthinkIntegration.webexUninstall.successMsgOnList',
    failure: 'chatBot.nexthinkIntegration.webexUninstall.failureMsg',
  },
}
